"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollTo = scrollTo;
exports.scrollToElement = scrollToElement;
var _isElement = _interopRequireDefault(require("lodash/isElement"));
var _isFinite = _interopRequireDefault(require("lodash/isFinite"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _smoothscrollPolyfill = _interopRequireDefault(require("smoothscroll-polyfill"));
var _env = _interopRequireDefault(require("../../utils/env/env"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Finds the position of an element for a given selector and scrolls it so that align point of the element
 * is positioned relative to the equivalent align point within the window or scrollable container
 * @selectorOrElement: {string}: the DOM selector for the element
 * @selectorOrElement: {DOM node}: a DOM element
 * @focus: {boolean}: optionally focus on the selector element
 * @focus: {string}: optionally focus on an element matching the provided selector string
 * @config: {object}: defines destination alignment and any offset, duration of scroll
 */
function scrollToElement(selectorOrElement, focus) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!_env["default"].isClient) {
    return;
  }

  // don't do this until we know we're not on the server
  _smoothscrollPolyfill["default"].polyfill();
  var el;
  if ((0, _isString["default"])(selectorOrElement)) {
    el = document.querySelector(selectorOrElement);
  } else if ((0, _isElement["default"])(selectorOrElement)) {
    el = selectorOrElement;
  }
  if (el) {
    setTimeout(function () {
      el.scrollIntoView({
        behavior: config.behavior || 'smooth',
        block: config.block || 'start'
      });
      if (focus) {
        var focusEl = (0, _isString["default"])(focus) ? document.querySelector(focus) : el;
        focusEl.focus();
      }
    }, 0);
  }
}
function scrollTo(scrollY) {
  if (!_env["default"].isClient) {
    return;
  }
  if ((0, _isFinite["default"])(scrollY)) {
    window.scrollTo(0, scrollY);
  }
}